import { apiCall } from "@/setup/webApi";

export const members = (request, signal = null) => {
  const queryString = new URLSearchParams(request).toString();

  return new Promise((resolve, reject) => {
    apiCall("get", `Export/members?${queryString}`, null, true, signal)
      .then((response) => {
        resolve(response);
      })
      .catch((ex) => {
        reject(ex);
      });
  });
};
